import {
  ProgressContainer,
  Progress,
  Track,
  type ProgressBarProps,
} from './Styles'

const ProgressBar = ({ color, paused }: ProgressBarProps) => (
  <ProgressContainer>
    <Track />
    <Progress color={color} paused={paused} />
  </ProgressContainer>
)

export default ProgressBar
